/**
 * Not Found Page (404)
 * Displayed when route is not found
 */

import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/common';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white px-4 py-8">
      <div className="max-w-2xl mx-auto space-y-6">
        {/* Page Header */}
        <div className="text-center mb-10">
          <h1 className="text-8xl font-bold text-neutral-200 mb-2">404</h1>
          <h2 className="text-4xl font-script text-primary-700 italic tracking-wide">
            Page Not Found
          </h2>
          <p className="text-sm text-neutral-500 mt-2">
            The page you are looking for does not exist or has been moved.
          </p>
        </div>

        {/* Help Information */}
        <div className="bg-neutral-50 rounded-2xl px-5 py-4 text-sm text-neutral-600 space-y-2">
          <p className="font-medium text-neutral-700">What you can do</p>
          <ul className="list-disc list-inside space-y-1 ml-1">
            <li>Check the URL for typos</li>
            <li>Go back to the login page</li>
            <li>Contact support if you believe this is an error</li>
          </ul>
        </div>

        {/* Action Button */}
        <div className="pt-4">
          <Button
            variant="primary"
            onClick={() => navigate('/login')}
            className="!rounded-full !px-8 !py-2.5 !bg-primary-500 hover:!bg-primary-600 !text-white !text-sm !font-medium"
          >
            Go to Login
          </Button>
        </div>
      </div>
    </div>
  );
}
